import { localUrl as appLocalUrl } from '../app-path.js';
import ApiClient from '../api-client.js';

const CLIMATEMPO_PORTAL_PRODUCT_ID = 3;

class SignupService {
	constructor() {
		this.apiClient = ApiClient;
	}

	buildFailure(response, fallbackMessage) {
		return {
			success: false,
			error: response?.error || fallbackMessage,
			errorDetails: response?.errorDetails || null,
		};
	}

	async sendOtp(email) {
		try {
			const response = await this.apiClient.post(appLocalUrl('/v2/json/signup/start'), {
				email: email,
			});

			if (response.success) {
				console.log('OTP enviado com sucesso');
				return {
					success: true,
					data: response.data,
				};
			} else {
				console.error('Erro ao enviar OTP (detalhes):', response.errorDetails);
				return this.buildFailure(
					response,
					'Erro ao enviar código de verificação',
				);
			}
		} catch (error) {
			console.error('Erro ao enviar OTP:', error);
			return {
				success: false,
				error: error.message || 'Erro ao enviar código de verificação',
				errorDetails: null,
			};
		}
	}

	async verifyOtp(email, otp) {
		try {
			const response = await this.apiClient.post(appLocalUrl('/v2/json/signup/validate-otp'), {
				email: email,
				otp: otp,
			});

			if (response.success) {
				console.log('OTP verificado com sucesso');
				return {
					success: true,
					data: response.data,
				};
			} else {
				console.error(
					'Erro ao verificar OTP (detalhes):',
					response.errorDetails,
				);
				return this.buildFailure(response, 'Código de verificação inválido');
			}
		} catch (error) {
			console.error('Erro ao verificar OTP:', error);
			return {
				success: false,
				error: error.message || 'Código de verificação inválido',
				errorDetails: null,
			};
		}
	}

	async completeRegistration(userData) {
		try {
			const response = await this.apiClient.post(appLocalUrl('/v2/json/signup/complete'), {
				email: userData.email,
				name: userData.name,
				cpf: userData.cpf,
				birthDate: userData.birthDate,
				password: userData.password,
				termsAccepted: userData.termsAccepted,
				portalProductId: CLIMATEMPO_PORTAL_PRODUCT_ID,
			});

			if (response.success) {
				console.log('Cadastro concluído com sucesso');
				return {
					success: true,
					redirect: appLocalUrl('/splash/cadastro'),
					data: response.data,
					user: response.data?.user,
				};
			} else {
				console.error(
					'Erro ao completar cadastro (detalhes):',
					response.errorDetails,
				);
				return this.buildFailure(response, 'Erro ao completar cadastro');
			}
		} catch (error) {
			console.error('Erro ao completar cadastro:', error);
			return {
				success: false,
				error: error.message || 'Erro ao completar cadastro',
				errorDetails: null,
			};
		}
	}

	async checkEmailExists(email) {
		try {
			const response = await this.apiClient.get(
				appLocalUrl(`/v2/json/signup/check-email?email=${encodeURIComponent(email)}`),
			);

			if (!response.success) {
				console.error(
					'Erro ao verificar email (detalhes):',
					response.errorDetails,
				);
				return this.buildFailure(response, 'Erro ao verificar email');
			}

			return {
				success: true,
				exists: response.data?.exists || false,
			};
		} catch (error) {
			console.error('Erro ao verificar email:', error);
			return {
				success: false,
				error: error.message || 'Erro ao verificar email',
				errorDetails: null,
			};
		}
	}
}

export default new SignupService();
